import { useOptimizedQuery } from "./useOptimizedQuery";
import { supabase } from "@/integrations/supabase/client";

/**
 * Centralized profile data fetching hook with intelligent caching
 * Uses 5-minute cache to prevent redundant profile requests
 */
export function useProfile(userId: string | undefined) {
  return useOptimizedQuery({
    queryKey: ['profile', userId],
    queryFn: async () => {
      if (!userId) return null;
      
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", userId)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!userId,
    dataType: 'semi-static', // 5 minute cache - profiles don't change often
  });
}
